"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_DATALAKE_CREATE_OR_UPDATE_PARTITION_EVENTS = exports.AthenaQueryResultTypeIterable = exports.AthenaTablePropertyType = exports.QuicksightEmbeddingErrorCodes = exports.QuicksightEmbedType = exports.TransformationOp = exports.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME = exports.REPORTING_DATE_FILE_VERSION_PARTITION_TABLES = exports.LOAN_PRODUCT_AND_CREDIT_FACILITY_DATALAKE_TABLE_NAME = exports.ONLY_CREDIT_FACILITY_DATALAKE_TABLE_NAME = exports.ONLY_LOAN_PRODUCT_DATALAKE_TABLE_NAME = exports.ALL_CREDIT_FACILITY_TABLE_PREFIXES = exports.ALL_TABLE_PREFIXES = exports.TablePrefix = exports.QuickSightDataType = void 0;
var QuickSightDataType;
(function (QuickSightDataType) {
    // *** Credit Facility Specific ***
    QuickSightDataType["MasterLoanTape"] = "masterLoanTape";
    QuickSightDataType["AssignedLoanTape"] = "assignedLoanTape";
    QuickSightDataType["ReceivableResponseTape"] = "receivableResponseTape";
    // *** Portfolio View ***
    QuickSightDataType["PortfolioReceivableResponseTape"] = "portfolioReceivableResponseTape";
})(QuickSightDataType = exports.QuickSightDataType || (exports.QuickSightDataType = {}));
/**
 * Athena table prefixes available in the datalake
 *
 * Party Permissions
 * - borrowers: all tables
 * - capProviders: only credit facility scoped tables
 */
var TablePrefix;
(function (TablePrefix) {
    // *** Loan Product Scoped ***
    TablePrefix["InternalRepaymentTapes"] = "internal_repayment_tapes";
    TablePrefix["InternalRepaymentTapesLatest"] = "internal_repayment_tapes_latest";
    TablePrefix["MasterLoanTapes"] = "master_loan_tapes";
    TablePrefix["MasterLoanTapesLatest"] = "master_loan_tapes_latest";
    // *** Credit Facility Scoped ***
    TablePrefix["BorrowingBaseReport"] = "borrowing_base_report";
    TablePrefix["BorrowingBaseReportLatest"] = "borrowing_base_report_latest";
    TablePrefix["CashResponseTapes"] = "cash_response_tapes";
    TablePrefix["CashResponseTapesLatest"] = "cash_response_tapes_latest";
    TablePrefix["ReceivableResponseTapes"] = "receivable_response_tapes";
    TablePrefix["ReceivableResponseTapesLatest"] = "receivable_response_tapes_latest";
    // *** Loan Product & Credit Facility Scoped ***
    TablePrefix["AssignedLoanTapes"] = "assigned_loan_tapes";
    TablePrefix["AssignedLoanTapesLatest"] = "assigned_loan_tapes_latest";
    TablePrefix["AssignedRepaymentTapes"] = "assigned_repayment_tapes";
    TablePrefix["AssignedRepaymentTapesLatest"] = "assigned_repayment_tapes_latest";
    TablePrefix["CovenantLoanTapes"] = "covenant_loan_tapes";
    TablePrefix["CovenantLoanTapesLatest"] = "covenant_loan_tapes_latest";
    // *** Financial Data: Entity (Org) & Period Scoped ***
    TablePrefix["FinancialStatement"] = "financial_statements";
    TablePrefix["FinancialStatementLatest"] = "financial_statements_latest";
})(TablePrefix = exports.TablePrefix || (exports.TablePrefix = {}));
exports.ALL_TABLE_PREFIXES = [
    TablePrefix.CashResponseTapes,
    TablePrefix.CashResponseTapesLatest,
    TablePrefix.CovenantLoanTapes,
    TablePrefix.CovenantLoanTapesLatest,
    TablePrefix.InternalRepaymentTapes,
    TablePrefix.InternalRepaymentTapesLatest,
    TablePrefix.MasterLoanTapes,
    TablePrefix.MasterLoanTapesLatest,
    TablePrefix.AssignedLoanTapes,
    TablePrefix.AssignedLoanTapesLatest,
    TablePrefix.AssignedRepaymentTapes,
    TablePrefix.AssignedRepaymentTapesLatest,
    TablePrefix.BorrowingBaseReport,
    TablePrefix.BorrowingBaseReportLatest,
    TablePrefix.ReceivableResponseTapes,
    TablePrefix.ReceivableResponseTapesLatest,
    TablePrefix.FinancialStatement,
    TablePrefix.FinancialStatementLatest,
];
exports.ALL_CREDIT_FACILITY_TABLE_PREFIXES = [
    TablePrefix.AssignedLoanTapes,
    TablePrefix.AssignedLoanTapesLatest,
    TablePrefix.AssignedRepaymentTapes,
    TablePrefix.AssignedRepaymentTapesLatest,
    TablePrefix.BorrowingBaseReport,
    TablePrefix.BorrowingBaseReportLatest,
    TablePrefix.CashResponseTapes,
    TablePrefix.CashResponseTapesLatest,
    TablePrefix.ReceivableResponseTapes,
    TablePrefix.ReceivableResponseTapesLatest,
];
/**
 * *** DATALAKE TABLE NAME STRUCTURE CATEGORIES ***
 *
 * For each of our Datalake tables, we prefix them with a set of options (above)
 * and each of them have a defined construct of how the table name is generated,
 * whether it includes LP slug, CF slug, or both.
 * Will need to monitor and update accordingly as we add more tables / variations
 */
exports.ONLY_LOAN_PRODUCT_DATALAKE_TABLE_NAME = [
    TablePrefix.InternalRepaymentTapes,
    TablePrefix.InternalRepaymentTapesLatest,
    TablePrefix.MasterLoanTapes,
    TablePrefix.MasterLoanTapesLatest,
];
exports.ONLY_CREDIT_FACILITY_DATALAKE_TABLE_NAME = [
    TablePrefix.BorrowingBaseReport,
    TablePrefix.BorrowingBaseReportLatest,
    TablePrefix.CashResponseTapes,
    TablePrefix.CashResponseTapesLatest,
    TablePrefix.ReceivableResponseTapes,
    TablePrefix.ReceivableResponseTapesLatest,
];
exports.LOAN_PRODUCT_AND_CREDIT_FACILITY_DATALAKE_TABLE_NAME = [
    TablePrefix.AssignedLoanTapes,
    TablePrefix.AssignedLoanTapesLatest,
    TablePrefix.AssignedRepaymentTapes,
    TablePrefix.AssignedRepaymentTapesLatest,
    TablePrefix.CovenantLoanTapes,
    TablePrefix.CovenantLoanTapesLatest,
];
// tables partitioned by reporting date / file version
exports.REPORTING_DATE_FILE_VERSION_PARTITION_TABLES = [
    TablePrefix.CashResponseTapes,
    TablePrefix.CashResponseTapesLatest,
    TablePrefix.CovenantLoanTapes,
    TablePrefix.CovenantLoanTapesLatest,
    TablePrefix.InternalRepaymentTapes,
    TablePrefix.InternalRepaymentTapesLatest,
    TablePrefix.MasterLoanTapes,
    TablePrefix.MasterLoanTapesLatest,
    TablePrefix.AssignedLoanTapes,
    TablePrefix.AssignedLoanTapesLatest,
    TablePrefix.AssignedRepaymentTapes,
    TablePrefix.AssignedRepaymentTapesLatest,
    TablePrefix.BorrowingBaseReport,
    TablePrefix.BorrowingBaseReportLatest,
    TablePrefix.ReceivableResponseTapes,
    TablePrefix.ReceivableResponseTapesLatest,
];
// tables partitions by fin statement, period, reporting date, version (file version)
exports.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME = [
    TablePrefix.FinancialStatement,
    TablePrefix.FinancialStatementLatest,
];
var TransformationOp;
(function (TransformationOp) {
    TransformationOp["AttachMetadata"] = "op_attach_metadata";
    TransformationOp["CastNumberFieldsAsDouble"] = "op_cast_number_fields_as_double";
    TransformationOp["Unnest"] = "op_unnest";
    TransformationOp["ResolveChoice"] = "op_resolve_choice";
    TransformationOp["ShortenColumnNames"] = "op_shorten_column_names";
    TransformationOp["WriteParquetToCurated"] = "op_write_parquet_to_curated";
    TransformationOp["NoOp"] = "op_none";
})(TransformationOp = exports.TransformationOp || (exports.TransformationOp = {}));
var QuicksightEmbedType;
(function (QuicksightEmbedType) {
    QuicksightEmbedType[QuicksightEmbedType["Dashboard"] = 0] = "Dashboard";
    QuicksightEmbedType[QuicksightEmbedType["Console"] = 1] = "Console";
})(QuicksightEmbedType = exports.QuicksightEmbedType || (exports.QuicksightEmbedType = {}));
var QuicksightEmbeddingErrorCodes;
(function (QuicksightEmbeddingErrorCodes) {
    QuicksightEmbeddingErrorCodes["DashboardIsNotConfiguredForQuicksight"] = "DashboardIsNotConfiguredForQuicksight";
    QuicksightEmbeddingErrorCodes["UserIsNotConfiguredForQuicksight"] = "UserIsNotConfiguredForQuicksight";
})(QuicksightEmbeddingErrorCodes = exports.QuicksightEmbeddingErrorCodes || (exports.QuicksightEmbeddingErrorCodes = {}));
// Athena data types
// https://docs.aws.amazon.com/athena/latest/ug/data-types.html
//
// NOTE: glue job data type differ from athena data types
// https://docs.aws.amazon.com/glue/latest/dg/aws-glue-programming-etl-connect.html
var AthenaTablePropertyType;
(function (AthenaTablePropertyType) {
    AthenaTablePropertyType["Boolean"] = "boolean";
    AthenaTablePropertyType["TinyInt"] = "tinyint";
    AthenaTablePropertyType["SmallInt"] = "smallint";
    AthenaTablePropertyType["Int"] = "int";
    AthenaTablePropertyType["Integer"] = "integer";
    AthenaTablePropertyType["BigInt"] = "bigint";
    AthenaTablePropertyType["Double"] = "double";
    AthenaTablePropertyType["Float"] = "float";
    AthenaTablePropertyType["Decimal"] = "decimal";
    AthenaTablePropertyType["Char"] = "char";
    AthenaTablePropertyType["Varchar"] = "varchar";
    AthenaTablePropertyType["String"] = "string";
    AthenaTablePropertyType["Binary"] = "binary";
    AthenaTablePropertyType["Date"] = "date";
    AthenaTablePropertyType["Timestamp"] = "timestamp";
    AthenaTablePropertyType["Array"] = "array";
    AthenaTablePropertyType["Map"] = "map";
    AthenaTablePropertyType["Struct"] = "struct";
})(AthenaTablePropertyType = exports.AthenaTablePropertyType || (exports.AthenaTablePropertyType = {}));
/**
 * These types are purely meant for Athena query results, where we can't
 * just rely on the Athena table schema (as SQL operations can alter types).
 * If possible, should use Athena table schema itself as it's more definitive
 */
exports.AthenaQueryResultTypeIterable = [
    'number',
    'string',
    'boolean',
];
// most often consumer should use this if interested in listening for specific partition hydration event
exports.ALL_DATALAKE_CREATE_OR_UPDATE_PARTITION_EVENTS = [
    'CreatePartition',
    'BatchCreatePartition',
    'UpdatePartition',
    'BatchUpdatePartition',
];
//# sourceMappingURL=DataLake.js.map